export function ProductWordmark({version}:{version?:string}){
 return <div className="product-wordmark" aria-label={`IPS Plant Manager${version?` ${version}`:""}`}><span className="product-wordmark-ips">IPS</span><span className="product-wordmark-name">Plant Manager</span>{version?<span className="product-wordmark-version">{version}</span>:null}</div>;
}
